import { Row, Col } from 'react-flexbox-grid';
import Input from "components/input"
import intl from 'react-intl-universal'
import HourRangeFilterInput from './styled';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types'

const HourRange = ({ hourFrom, hourTo, labelFrom, labelTo, onChangeDeliveryTimeMin, onChangeDeliveryTimeMax, onRangeIsValid }) => {
  const [invalidPeriod, setInvalidPeriod] = useState(false);

  const validateHoursPeriod = () => {
    if (hourFrom && hourTo && hourFrom > hourTo) {
      setInvalidPeriod(true)
    }
    else {
      setInvalidPeriod(false)
    }

    onRangeIsValid(invalidPeriod)
  }


  useEffect(() => {
    validateHoursPeriod()
  }, [hourFrom, hourTo, invalidPeriod])

  return (
    <Row>
      <Col xs={6} lg={6} md={6}>
        <HourRangeFilterInput>
          <Input
            label={labelFrom}
            name='DeliveryTimeMin'
            htmlType='time'
            value={hourFrom}
            onChange={e => onChangeDeliveryTimeMin(e.target.value, hourFrom)}
          />
        </HourRangeFilterInput>
      </Col>
      <Col xs={6} lg={6} md={6}>
        <HourRangeFilterInput>
          <Input
            label={labelTo}
            name='DeliveryTimeMax'
            htmlType='time'
            value={hourTo}
            onChange={e => onChangeDeliveryTimeMax(e.target.value, hourTo)}
          />
        </HourRangeFilterInput>
      </Col>

      {invalidPeriod &&
        <div className="range-data-mensagem">
          <span>{intl.get('commons.invalidPeriod')}</span>
        </div>
      }
    </Row>
  )
}

HourRange.propTypes = {
  labelTo: PropTypes.string,
  hourTo: PropTypes.string,
  hourFrom: PropTypes.string,
  labelFrom: PropTypes.string,
  onChangeDeliveryTimeMin: PropTypes.func,
  onRangeIsValid: PropTypes.func,
  onChangeDeliveryTimeMax: PropTypes.func
}

export default HourRange;